// extracted by mini-css-extract-plugin
module.exports = {"rg_widget__head":"rg_widget__head--2nUtU5Q1G","rg_widget__body":"rg_widget__body--2xOd8LVwW","widget":"widget--3J81AT1gb","large":"large--3WX6IhCDs"};